// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

up.compiler('[add-cart-item]', function(element, data) {
  function removeEmptyListPlaceholder() {
    const noItemsElement = element.closest('form').querySelector('.new-cart-items--no-items')
    if (noItemsElement) {
      noItemsElement.remove()
    }
  }

  function updateTotalAmount() {
    up.validate(element.closest('form'), { target: '.new-cart-items--total' })
  }

  function insertItem(response) {
    const div = document.createElement('div')
    div.innerHTML = response.text.trim()

    const orderItemsList = element.closest('form').querySelector('.new-cart-items--list')
    const referenceElement = orderItemsList.querySelector(data.insert_before)
    const newItem = div.querySelector('.new-cart-item')
    orderItemsList.insertBefore(newItem, referenceElement)

    up.hello(newItem)
  }

  function newItemPosition() {
    const positionAttribute = 'new-cart-item-position'
    const orderItemPositionElement = element.closest('form').querySelector(`[${positionAttribute}]`)
    let position = orderItemPositionElement.getAttribute(positionAttribute) || 0

    position++
    orderItemPositionElement.setAttribute(positionAttribute, position)

    return position
  }

  function addOrderItem() {
    const requestUrl = element.getAttribute('href')
    const params = { position: newItemPosition(), type: data.type }

    up.request(requestUrl, { params }).then(function(response) {
      insertItem(response)
      removeEmptyListPlaceholder()
      updateTotalAmount()
    })
  }

  element.addEventListener('click', (e) => {
    e.preventDefault()
    addOrderItem()
  })
})
